/*
 * Single entry point for "the session can no longer be refreshed".
 *
 * ApiService calls this once the refresh endpoint has definitively rejected the refresh
 * token. The work is done by the session-expiry plugin (app/plugins/session-expiry.client.ts):
 * one clear of auth state, one message, one redirect to login, in every layout and on
 * native. The plugin guards against a burst of 401s expiring the session more than once.
 *
 * The DOM `logout` event is kept only as a fallback for a context where the plugin has
 * not been provided (unit tests that build an ApiService without the Nuxt app).
 */
export const expireSession = ({ reason } = {}) => {
  if (!import.meta.client) return false

  const nuxtApp = useNuxtApp()
  if (typeof nuxtApp?.$expireSession === 'function') {
    nuxtApp.$expireSession({ reason })
    return true
  }

  dispatchEvent('logout', { reason })
  return true
}
